import { Link } from 'react-router';
import cn from 'classnames';

import { setInlineBackgroundColor, setInlineTextColor } from 'helpers/LandingPageUtils';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import { stripSpecialChars } from 'helpers';

import css from 'styles/components/landing/melodyCurated.scss';

const MelodyCurated = ({ slotName, slotIndex, slotDetails, onLandingComponentClick, slotHeartsData }) => {
  const { products, title, link, ctacopy, copy, bgcolor, gae, textcolor, flip, monetateId } = slotDetails;

  const makeTitle = () => title && <h2 style={setInlineTextColor(textcolor)}>{title}</h2>;

  const makeCopy = () => copy && <p style={setInlineTextColor(textcolor)}>{copy}</p>;

  const makeCallToAction = () => ctacopy && <p className={css.cta}>{ctacopy}</p>;

  const makeMainContent = () => {
    const styling = (textcolor === 'white') ? css.mainContentCtaWhite : css.mainContentCtaDefault;
    return (
      <div className={cn(css.mainContentContainer, styling)} style={setInlineBackgroundColor(bgcolor)}>
        <Link
          to={link}
          onClick={onLandingComponentClick}
          data-eventlabel="melodyCurated"
          data-slotindex={slotIndex}
          data-eventvalue={ gae || title }>
          {makeTitle()}
          {makeCopy()}
          {makeCallToAction()}
        </Link>
      </div>
    );
  };

  return (
    <div className={cn(css.mCurated, { [css.flipped]: flip === 'true' })} data-slot-id={slotName} data-monetate-id={monetateId}>
      {makeMainContent()}
      {products.map((product, i) => {
        const { msaImageUrl, thumbnailImageUrl, src } = product;
        return <MelodyCardProduct
          key={`${stripSpecialChars(msaImageUrl || thumbnailImageUrl || src)}_${i}`}
          cardData={product}
          componentStyle="melodyCurated"
          eventLabel="melodyCurated"
          onComponentClick={onLandingComponentClick}
          heartsData={slotHeartsData} />;
      })}
    </div>
  );
};

export default MelodyCurated;
